import BigNumber from 'bignumber.js';
import { RATIO_PRECISION } from '@paradigm/features/src/unified-rfqs/ui/ratio-precision';
import { getProduct } from '#/products/domain';
import { venueSupportsCustomStrategy } from '#/unified-rfqs/entities/products/venue';

export function ratioView(
  ratio: string,
  selectedProductCode: string,
  isOrderBook = false,
) {
  const product = getProduct(selectedProductCode);
  const auctionType = isOrderBook ? 'OB' : 'RFQ';
  const precision = RATIO_PRECISION[auctionType][product.kind];

  const bnValue = BigNumber(ratio);
  const isValid = bnValue.isFinite() && bnValue.isGreaterThan(0);
  const value = bnValue.isFinite() ? bnValue.dp(precision).toString() : '';

  const isDisabled =
    !isOrderBook || !venueSupportsCustomStrategy(product.venue);

  return {
    value,
    precision,
    isValid,
    isDisabled,
  };
}
